export default __webpack_public_path__ + "static/media/logo1024x1024.9edc15ea.png";